import React, { useContext, useEffect, useState } from 'react'
import '../css/ModifierClientStock.css'
import axios from 'axios';
import LoadingComponent from './LoadingComponent';

function ModifierClientStock({ modifierClientStockActive, setModifierClientStockActive, getVehicules, refreshHandle, clientId, setClientId, vehiculeId }) {
    const [demande, setDemande] = useState({});
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setDemande([]);
        setError(null);
    }, [clientId])

    useEffect(() => {
        if (modifierClientStockActive === true) {
            chargerSubmit();
        }
    }, [modifierClientStockActive])

    const chargerSubmit = async () => {
        setIsFetching(true);
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/taksit/rest/get/creditDemandes2`,
            JSON.stringify({ id: clientId }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                    // 'Content-Type': 'application/json'
                },
            }).then(res => {
                if (res.data.errorCode === 7 || res.data.errorCode === 5) {
                    setDemande({});
                    setIsFetching(false);
                    setError(res.data.errorMessage);
                } else {
                    if(res.data.demande !== null){
                        setDemande(res.data.demande);
                        setIsFetching(false);
                        setError(null);
                    }else{
                        setDemande({});
                        setIsFetching(false);
                        setError("Id Introuvable");
                    }
                }
            }).catch((err) => {
                setIsFetching(false);
            });
    }

    const validateSubmit = async (e) => {
        let queryBody = {};
        if(Object.keys(demande).length !== 0){
            queryBody = { username: 'ghsggs&@gdsfd', password: 'hdgs@&hdjshus@sq', id: vehiculeId, client: clientId, montant: demande.mt_produit}
        }else{
            queryBody = { username: 'ghsggs&@gdsfd', password: 'hdgs@&hdjshus@sq', id: vehiculeId, client: "", montant: 0}
        }
        await axios
        .post(`http://localhost:8000/api/vehicule/attachVehiculeClient`,
            JSON.stringify(queryBody),
            {
                headers: {
                    //'Content-Type': 'application/x-www-form-urlencoded'
                    'Content-Type': 'application/json'
                },
            })
        .then((res) => {
            getVehicules(); 
            setDemande({});
            setIsFetching(false);
            setError(null);
            setModifierClientStockActive(false);
        })
        .catch((err) => {
            console.log(err);
        });
    }


    return (
        <div style={{ display: modifierClientStockActive == true ? 'block' : 'none' }} className='consult-group'>
            <div className='wrapper' onClick={() => setModifierClientStockActive(false)}></div>
            <div className='validate-box'>
                <div className='validate-title'>
                    <span>Attacher un Client</span>
                </div>
                <div className='validate-form'>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <label htmlFor="client">Client</label>
                        </div>
                        <div className='col-lg-9'>
                            <input id="client" name="client" className="form-control" value={clientId} onChange={e => setClientId(e.target.value)} />
                        </div>
                    </div>
                    <>
                        {
                            error && (
                                <div className='row'>
                                    <div className='line error'>
                                        <span>Error :</span>
                                        <span style={{ margin: "0 5px"}}>{error} </span>
                                    </div>
                                </div>
                            )
                        }
                        {
                            isFetching ? (<LoadingComponent />) : (
                                (Object.keys(demande).length !== 0) && (
                                    <div className='row'>
                                        <div className='line'>
                                            <span>Nom :</span>
                                            <span style={{ margin: "0 5px", color: "#a7a7a7", }}>{demande.nom} </span>
                                        </div>
                                        <div className='line'>
                                            <span>Prenom :</span>
                                            <span style={{ margin: "0 5px", color: "#a7a7a7", }}>{demande.prenom} </span>
                                        </div>
                                        <div className='line'>
                                            <span>Date Naissance :</span>
                                            <span style={{ margin: "0 5px", color: "#a7a7a7", }}>{demande.dateNaissance} </span>
                                        </div>
                                        <div className='line'>
                                            <span>Mobile :</span>
                                            <span style={{ margin: "0 5px", color: "#a7a7a7", }}>{demande.mobile} </span>
                                        </div>
                                        <div className='line'>
                                            <span>Montant Produit :</span>
                                            <span style={{ margin: "0 5px", color: "#a7a7a7", }}>{demande.mt_produit} </span>
                                        </div>
                                    </div>
                                )
                            )
                        }
                    </>
                    <div className='row'>
                        <div className='validate-submit'>
                            <span onClick={(e) => chargerSubmit(e)}>Charger</span>
                            <span onClick={(e) => validateSubmit(e)}>Valider</span>
                        </div>
                    </div>
                </div>
                {/* <ul>
                    {
                        consultGroupList.map((item,idx)=>{
                            return (<li key={idx}>{item}</li>)
                        })
                    }
                </ul> */}
            </div>

        </div>
    )
}

export default ModifierClientStock